module.exports = __webpack_public_path__ + "static/media/winner.d558ea76.svg";